module.exports = __webpack_public_path__ + "img/MovinOnUpPoker_EGM.f9ad0d8c.png";